import SectionWrapper from '@/components/feature/SectionWrapper';
import SEO, { siteUrl } from '@/components/feature/SEO';

const WHATSAPP_URL = 'https://wa.me/923179699957?text=Hi%20Moin%20Khan%20Boxing%20Academy!%20I%20want%20to%20join%20training';
const PHONE_NUMBER = '0317-9699957';

const locations = [
  {
    name: 'Phase 7, Bahria Town',
    address: 'Islamabad, Pakistan',
    area: 'Bahria Town',
    description: 'Our main training facility in Bahria Town features a full boxing ring, heavy bags, speed bags, and professional conditioning equipment.',
    mapImage: 'https://readdy.ai/api/search-image?query=Aerial%20satellite%20view%20style%20map%20preview%20of%20Bahria%20Town%20Islamabad%20residential%20area%20with%20green%20parks%20and%20modern%20roads%2C%20dark%20cinematic%20overlay%20with%20red%20accent%20markers%2C%20premium%20location%20map%20style%2C%20clean%20minimalist%20cartography%20design%20with%20subtle%20red%20pin%20marker&width=800&height=400&seq=map-bahria&orientation=landscape',
  },
  {
    name: 'DHA Phase 2',
    address: 'Islamabad, Pakistan',
    area: 'DHA-2',
    description: 'Premium training space in DHA-2 with top-tier equipment, private training areas, and group training facilities.',
    mapImage: 'https://readdy.ai/api/search-image?query=Aerial%20satellite%20view%20style%20map%20preview%20of%20DHA%20Phase%202%20Islamabad%20residential%20area%20with%20modern%20infrastructure%20and%20green%20spaces%2C%20dark%20cinematic%20overlay%20with%20red%20accent%20markers%2C%20premium%20location%20map%20style%2C%20clean%20minimalist%20cartography%20design%20with%20subtle%20red%20pin%20marker&width=800&height=400&seq=map-dha&orientation=landscape',
  },
];

export default function Contact() {
  return (
    <main>
      <SEO
        title="Contact Us — Moin Khan Boxing Academy | Islamabad Locations"
        description="Contact Moin Khan Boxing Academy via WhatsApp or phone. Two locations in Islamabad — Bahria Town Phase 7 and DHA Phase 2. Book your first boxing training session today."
        keywords="contact Moin Khan, boxing academy Islamabad, Bahria Town boxing gym, DHA boxing training, boxing gym contact Islamabad"
        canonicalUrl={siteUrl ? `${siteUrl}/contact` : undefined}
        jsonLd={[
          {
            '@context': 'https://schema.org',
            '@type': 'ContactPage',
            '@id': `${siteUrl}/contact#page`,
            url: `${siteUrl}/contact`,
            name: 'Contact Moin Khan Boxing Academy',
            description: 'Get in touch with Moin Khan Boxing Academy. Reach out via WhatsApp or call us directly. We respond within minutes.',
            mainEntity: {
              '@type': 'Organization',
              '@id': `${siteUrl}/#organization`,
              name: 'Moin Khan Boxing Academy',
              telephone: '+923179699957',
              contactPoint: {
                '@type': 'ContactPoint',
                contactType: 'customer service',
                telephone: '+923179699957',
                availableLanguage: ['English', 'Urdu'],
              },
              address: [
                {
                  '@type': 'PostalAddress',
                  streetAddress: 'Phase 7, Bahria Town',
                  addressLocality: 'Islamabad',
                  addressCountry: 'PK',
                },
                {
                  '@type': 'PostalAddress',
                  streetAddress: 'DHA Phase 2',
                  addressLocality: 'Islamabad',
                  addressCountry: 'PK',
                },
              ],
            },
          },
        ]}
      />
      {/* Hero Banner */}
      <section className="relative pt-24 md:pt-28 pb-10 md:pb-14 overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img
            src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20boxing%20gym%20entrance%20with%20dramatic%20red%20lighting%20on%20black%20background%2C%20professional%20sports%20photography%2C%20high%20contrast%2C%20premium%20gym%20facade%2C%20moody%20atmosphere%2C%20intense%20environment&width=1920&height=600&seq=contact-hero-2&orientation=landscape"
            alt="Contact"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-boxing-black/70" />
          <div className="absolute inset-0 bg-gradient-to-t from-boxing-black via-transparent to-boxing-black/40" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-8 lg:px-12 text-center">
          <SectionWrapper>
            <span className="section-label">/ Get in Touch</span>
            <h1 className="heading-mixed text-4xl sm:text-5xl md:text-6xl lg:text-7xl">
              Contact <span className="text-highlight">Us</span>
            </h1>
            <p className="font-poppins text-white/60 text-sm md:text-base max-w-xl mx-auto mt-4">
              Ready to start? Reach out via WhatsApp or call us directly. We respond within minutes.
            </p>
          </SectionWrapper>
        </div>
      </section>

      {/* Contact Cards */}
      <section className="bg-boxing-black py-8 md:py-12">
        <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-12 md:mb-16">
            <SectionWrapper>
              <div className="card-glow bg-boxing-darker rounded-xl p-6 md:p-7 text-center">
                <span className="w-14 h-14 flex items-center justify-center bg-boxing-red/10 rounded-full mx-auto mb-4">
                  <i className="ri-whatsapp-line text-boxing-red text-2xl" />
                </span>
                <h3 className="font-oswald uppercase text-base tracking-wide text-white mb-2">
                  WhatsApp
                </h3>
                <p className="text-boxing-textgray text-sm mb-4">
                  Fastest way to reach us. We reply within minutes.
                </p>
                <a
                  href={WHATSAPP_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-primary text-xs w-full"
                >
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-whatsapp-line text-sm" />
                  </span>
                  Message on WhatsApp
                </a>
              </div>
            </SectionWrapper>

            <SectionWrapper delay={120}>
              <div className="card-glow bg-boxing-darker rounded-xl p-6 md:p-7 text-center">
                <span className="w-14 h-14 flex items-center justify-center bg-boxing-red/10 rounded-full mx-auto mb-4">
                  <i className="ri-phone-line text-boxing-red text-2xl" />
                </span>
                <h3 className="font-oswald uppercase text-base tracking-wide text-white mb-2">
                  Call Us
                </h3>
                <p className="text-boxing-textgray text-sm mb-4">
                  Speak directly with the team.
                </p>
                <a
                  href={`tel:+92${PHONE_NUMBER.replace(/-/g, '')}`}
                  className="btn-primary text-xs w-full"
                >
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-phone-line text-sm" />
                  </span>
                  {PHONE_NUMBER}
                </a>
              </div>
            </SectionWrapper>

            <SectionWrapper delay={240}>
              <div className="card-glow bg-boxing-darker rounded-xl p-6 md:p-7 text-center">
                <span className="w-14 h-14 flex items-center justify-center bg-boxing-red/10 rounded-full mx-auto mb-4">
                  <i className="ri-map-pin-line text-boxing-red text-2xl" />
                </span>
                <h3 className="font-oswald uppercase text-base tracking-wide text-white mb-2">
                  Locations
                </h3>
                <p className="text-boxing-textgray text-sm mb-4">
                  Two convenient locations in Islamabad.
                </p>
                <span className="text-white text-sm font-oswald uppercase tracking-wide">
                  Bahria Town & DHA-2
                </span>
              </div>
            </SectionWrapper>
          </div>

          {/* Locations */}
          <SectionWrapper className="text-center mb-10 md:mb-14">
            <span className="section-label">/ Our Locations</span>
            <h2 className="heading-mixed text-3xl md:text-4xl lg:text-5xl">
              Where to <span className="text-highlight">Find Us</span>
            </h2>
            <div className="w-16 h-[2px] bg-boxing-red mx-auto mt-6" />
          </SectionWrapper>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
            {locations.map((loc, index) => (
              <SectionWrapper key={loc.area} delay={index * 120}>
                <div className="card-glow bg-boxing-darker rounded-xl overflow-hidden">
                  {/* Map preview image */}
                  <div className="h-48 md:h-56 overflow-hidden relative">
                    <img
                      src={loc.mapImage}
                      alt={`${loc.name} location map`}
                      className="w-full h-full object-cover object-top transition-transform duration-700 hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-boxing-darker via-transparent to-transparent" />
                    <div className="absolute bottom-3 left-4 flex items-center gap-2">
                      <span className="w-8 h-8 flex items-center justify-center bg-boxing-red rounded-full shadow-red-glow">
                        <i className="ri-map-pin-fill text-white text-sm" />
                      </span>
                    </div>
                  </div>
                  <div className="p-5 md:p-6">
                    <h3 className="font-oswald uppercase text-base md:text-lg tracking-wide text-white mb-1">
                      {loc.name}
                    </h3>
                    <p className="text-boxing-textgray text-xs md:text-sm mb-3">
                      {loc.address}
                    </p>
                    <p className="text-white/60 text-sm leading-relaxed mb-5">
                      {loc.description}
                    </p>
                    <div className="flex flex-col sm:flex-row gap-3">
                      <a
                        href={WHATSAPP_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn-primary text-xs flex-1"
                      >
                        <span className="w-4 h-4 flex items-center justify-center">
                          <i className="ri-whatsapp-line text-sm" />
                        </span>
                        Enquire Now
                      </a>
                      <a
                        href={`tel:+92${PHONE_NUMBER.replace(/-/g, '')}`}
                        className="btn-secondary text-xs flex-1"
                      >
                        <span className="w-4 h-4 flex items-center justify-center">
                          <i className="ri-phone-line text-sm" />
                        </span>
                        Call Now
                      </a>
                    </div>
                  </div>
                </div>
              </SectionWrapper>
            ))}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="bg-boxing-darker py-14 md:py-20">
        <div className="max-w-3xl mx-auto px-5 md:px-8 lg:px-12 text-center">
          <SectionWrapper>
            <h2 className="heading-mixed text-3xl md:text-4xl lg:text-5xl">
              Start Your Boxing
              <br />
              <span className="text-highlight">Journey Today</span>
            </h2>
            <p className="text-white/60 text-sm md:text-base mt-5 mb-8">
              Whether you are a beginner or a competitive fighter, we have a program for you. Message us and we will get back to you right away.
            </p>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary text-sm md:text-base px-10 py-4"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-whatsapp-line text-lg" />
              </span>
              Join Now via WhatsApp
            </a>
          </SectionWrapper>
        </div>
      </section>
    </main>
  );
}
